// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"5ab7dcb6","404":"2e6a20a7"}[chunkId] + ".chunk.js";
};